import * as React from "react"
import { Toast, ToastContainer, ToastDescription, ToastTitle } from "./toast"
import { useToast } from "./use-toast"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <ToastContainer>
      {toasts.map(({ id, title, description, variant, ...props }) => {
        return (
          <Toast
            key={id}
            variant={variant}
            {...props}
            onClick={() => dismiss(id)}
          >
            <div className="grid gap-1">
              {title && <ToastTitle>{title}</ToastTitle>}
              {description && (
                <ToastDescription>{description}</ToastDescription>
              )}
            </div>
          </Toast>
        )
      })}
    </ToastContainer>
  )
}
